var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('waiter',{ref:"waiter"},[_c('x-tree',{ref:"xtree",attrs:{"data":_vm.groupsTree,"options":_vm.treeOptions},on:{"add":_vm.onAdd,"edit":_vm.onEdit,"delete":_vm.onDelete,"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }